export default __webpack_public_path__ + "static/media/cs.58fdf961.jpg";